// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_80ad21f8ef--wrapper--3807X","title":"_80ad21f8ef--title--S0rsn"};